import React from 'react';
import { Route } from 'react-router-dom';

import { ADMIN_DELIVERY_ZONES_APP_PATHS } from '../constants/delivery-zones-app-paths.constants';
import AdminDeliveryZonesListView from '../views/admin/AdminDeliveryZonesList.view';
import AdminDeliveryZoneDetailsView from '../views/admin/AdminDeliveryZoneDetails.view';

export default function AdminDeliveryZonesRoutes() {
  return (
    <React.Fragment>
      <Route exact path={ADMIN_DELIVERY_ZONES_APP_PATHS.DELIVERY_ZONES_LIST} component={AdminDeliveryZonesListView} />
      <Route
        exact
        path={ADMIN_DELIVERY_ZONES_APP_PATHS.DELIVERY_ZONE_DETAILS}
        component={AdminDeliveryZoneDetailsView}
      />
    </React.Fragment>
  );
}
